export const TALK_YOUTUBE_CHANNEL =
	'https://www.youtube.com/channel/UCVDro8TZ8GiEj3B0RXBZhHw?sub_confirmation=1';
